import { Component } from '@angular/core';

import type { CardData } from '@shared/components';
import { YoutubePlayerComponent, AutoExpandableCardsComponent } from '@shared/components';

@Component({
  selector: 'app-evrn-method',
  imports: [AutoExpandableCardsComponent, YoutubePlayerComponent],
  templateUrl: './evrn-method.html',
  styleUrl: './evrn-method.scss',
})
export class EvrnMethod {
  readonly steps: CardData[] = [
    {
      video: 'assets/evrn-method/vinod-step-1.webm',
      title: '2D to 3D Scene',
      description: 'Turn any flat picture into a full 3D scene of separate meshes.',
      duration: 16000,
    },
    {
      video: 'assets/evrn-method/vinod-step-2.webm',
      title: 'Layout Reference',
      description: 'Direct the scene with your cameras, your assets, and your light.',
      duration: 19000,
    },
    {
      video: 'assets/evrn-method/vinod-step-3.webm',
      title: 'Generative Video',
      description: 'Bring the layout reference to your AI model for consistent renders.',
      duration: 10000,
    },
  ];
}
